// extracted by mini-css-extract-plugin
export default {"container":"GeneralFinancialInfo_container__dHydm"};